import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class ButtonHandler {
	constructor(startButton, nextButton, signupButton, sendButton) {
		let started = true;
		helper.triggerEvent(window, Events.START_ACTION);

		helper.addEventListener(nextButton, 'click', (evt) => {
			evt.preventDefault();
			if (started) {
				helper.triggerEvent(window, Events.SHOW_NEXT_GIRL);
			} else {
				helper.addClass(startButton, 'pulse');
			}
		});

		helper.addEventListener(signupButton, 'click', (evt) => {
			evt.preventDefault();
			if (started) {
				helper.triggerEvent(window, Events.CREATE_SIGNUP);
			} else {
				helper.addClass(startButton, 'pulse');
			}
		});

		helper.addEventListener(sendButton, 'click', (evt) => {
			evt.preventDefault();
			if (started) {
				helper.triggerEvent(window, Events.CREATE_SIGNUP);
			} else {
				helper.addClass(startButton, 'pulse');
			}
		});

		helper.addEventListener(window, Events.SENT_MESSAGE, () => {
			if (!started) {
				helper.addClass(startButton, 'pulse');
			}
		});
	}
}
